<div class="mango-list-view">
  <div class="btn-group mr-2" role="group">
    <button type="button"
            class="btn"
            [ngClass]="{'selected-view': selected === 'list'}"
            (click)="btnSelected('list')">
      <i class="fa fa-list"></i>
    </button>
    <button type="button"
            class="btn"
            [ngClass]="{'selected-view': selected === 'grid'}"
            (click)="btnSelected('grid')">
      <i class="fa fa-th-large"></i>
    </button>
  </div>
</div>
